import React, { ReactNode } from 'react';

import { Grid, Icon, IconName, Margin, Text } from '@zapier/design-system';

type Props = {
  description: ReactNode;
  icon: IconName;
  title: string;
};

function TodoItem({ description, icon, title }: Props) {
  return (
    <Margin key={title} margin="10px 0px 30px">
      <Grid alignItems="start" columns="auto 1fr" gap="10px">
        <Icon name={icon} size={24} />
        <Text fontWeight={700} margin="0px 0px 15px" tag="h3" type="Body4">
          {title}
        </Text>
      </Grid>
      <Text type="Body1">{description}</Text>
    </Margin>
  );
}

export default TodoItem;
